module.exports = __webpack_public_path__ + "static/media/internet_image.4ae29ba9.png";